module.exports = __webpack_public_path__ + "img/5fce78b5-8086-4fe5-9dd8-664078b4d09b.4dd25693.jpg";